import React from 'react'

const e = React.createElement;


function GraphWeeks(props) {
  React.Component.constructor.call(this);

  this.state = {graph_offset:null};
}
GraphWeeks.prototype = Object.create(React.Component.prototype);


GraphWeeks.prototype.componentDidUpdate = function() {
  var canvas_wrapper = document.getElementById("graphweeks-wrapper");
  var canvas = document.getElementById("canvasweeks");
  if(this.state.graph_offset === null && canvas_wrapper && canvas && canvas.width > 0) {
    var max_width = canvas_wrapper.offsetWidth;
    var new_graph_offset = -(canvas.width - max_width);
    this.setState({graph_offset:new_graph_offset});
  }
}

GraphWeeks.prototype.render = function() {
  const data = this.props.data;
  const groups = this.props.groups ? this.props.groups : null;
  const filtered = this.props.filtered ? this.props.filtered : null;
  var canvas = document.getElementById("canvasweeks");

  if(canvas && data[0] !== undefined) {
    var ctx = canvas.getContext("2d");
    var values = {};
    data.map(function(item, i) {
      if(filtered && item.app_id !== filtered) {return;}
      var d = new Date(item.created_on);
      var key = d.getWeek();
      if(groups) {
        if(values[key] === undefined) {
          values[key] = {};
          var is_rest = true;
          for(var group_label in groups) {
            values[key][group_label] = 0;
            if(item.app_id === group_label) {
              values[key][group_label] = 1;
              is_rest = false;
            }
          }
          if(is_rest) values[key]["rest"] = 1;
        } else {
          var is_rest = true;
          for(var group_label in groups) {
            if(item.app_id === group_label) {
              values[key][group_label] += 1;
              is_rest = false;
            }
          }
          if(is_rest) values[key]["rest"] += 1;
        }
      } else {
        if(values[key] === undefined) {
          values[key] = 1;
        } else {
          values[key]++;
        }
      }
    });

    var max_value = 0;
    if(groups) {
      for(var i in values) {
        var group_value = 0;
        for(var i2 in values[i]) {
          group_value += values[i][i2];
        }
        if(group_value > max_value) max_value = group_value;
      }
    } else {
      for(var i in values) {
        if(values[i] > max_value) max_value = values[i];
      }
    }

    var d = new Date(data[data.length - 1].created_on);
    var first_key = d.getWeek();
    var d2 = new Date(data[0].created_on);
    var last_key = d2.getWeek();
    var last_day_key = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();

    var dates = {}, day_count = {};
    for(var loop_stop = 0; loop_stop < 1;) {
      var key = d.getWeek();
      var day_key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      dates[key] = 0;
      if(day_count[key] === undefined) {
        day_count[key] = 1;
      } else {
        day_count[key] += 1;
      }

      d.setDate(d.getDate() + 1);
      if(key === last_key && day_key === last_day_key) {
        loop_stop++;
      }
    }

    canvas.width = Object.keys(dates).length * 20 - 10;

    ctx.fillStyle = "#222222";
    var dates_i = 0;
    for(var key in dates) {
      if(values[key]) {
        if(groups) {
          var perc_offset = 0;
          for(var group_label in groups) {
            ctx.fillStyle = groups[group_label]+((day_count[key] === 7 && key !== ""+last_key) ? "" : "26");
            var perc = Math.floor(values[key][group_label] / max_value * 100);
            ctx.fillRect(0+dates_i*20, 100-perc-perc_offset, 10, perc);
            perc_offset += perc;
          }
          ctx.fillStyle = "#222222";
        } else {
          var perc = Math.floor(values[key] / max_value * 100);
          ctx.fillRect(0+dates_i*20, 100-perc, 10, perc);
        }
      }

      ctx.fillText(key, -1+dates_i*20, 110);

      dates_i++;
    }
  } else if(!canvas) {
    setTimeout(function() {
      this.setState({reload:true});
    }.bind(this), 0);
  }

  return e('div', {className:"card"}, e('div', {id:"graphweeks-wrapper", style:{overflow:"hidden"}}, [
    e('span', {key:"left", className:"graph-arrow", onClick:this.moveGraph.bind(this, false)}, "<"),
    e('span', {key:"right", className:"graph-arrow", onClick:this.moveGraph.bind(this, true), style:{marginLeft:"22px"}}, ">"),
    e('span', {key:"max", style:{float:"right", fontSize:"62%", opacity:".4"}}, max_value && "max. "+max_value),
    e('canvas', {key:"canvasweeks", id:"canvasweeks", width:"0px", height:"120px", style:{marginLeft:this.state.graph_offset}})
  ]));
}

GraphWeeks.prototype.moveGraph = function(move_right) {
  var canvas_wrapper = document.getElementById("graphweeks-wrapper");
  var max_width = canvas_wrapper.offsetWidth;
  var canvas = document.getElementById("canvasweeks");

  var new_offset = -120;
  var new_graph_offset = this.state.graph_offset;
  if(canvas.width > 0) {
    if(!move_right && new_graph_offset < 0) {
      new_graph_offset = this.state.graph_offset - new_offset;
      if(new_graph_offset > 0) new_graph_offset = 0;
    }
    if(move_right && canvas.width + this.state.graph_offset > max_width) {
      new_graph_offset = this.state.graph_offset + new_offset;
      if(canvas.width + new_graph_offset < max_width) new_graph_offset = -(canvas.width - max_width);
    }
  }
  this.setState({graph_offset:new_graph_offset});
}

/**
 * Returns the week number for this date.  dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
Date.prototype.getWeek = function (dowOffset) {
/*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */

  dowOffset = typeof(dowOffset) == 'number' ? dowOffset : 0; //default dowOffset to zero
  var newYear = new Date(this.getFullYear(),0,1);
  var day = newYear.getDay() - dowOffset; //the day of week the year begins on
  day = (day >= 0 ? day : day + 7);
  var daynum = Math.floor((this.getTime() - newYear.getTime() - 
  (this.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
  var weeknum;
  //if the year starts before the middle of a week
  if(day < 4) {
    weeknum = Math.floor((daynum+day-1)/7) + 1;
    if(weeknum > 52) {
      var nYear = new Date(this.getFullYear() + 1,0,1);
      var nday = nYear.getDay() - dowOffset;
      nday = nday >= 0 ? nday : nday + 7;
      /*if the next year starts before the middle of
        the week, it is week #1 of that year*/
      weeknum = nday < 4 ? 1 : 53;
    }
  }
  else {
    weeknum = Math.floor((daynum+day-1)/7);
  }
  return weeknum;
};


export default GraphWeeks



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/GraphWeeks.js
// module id = 194
// module chunks = 0